import axios from 'axios';

export default function () {
  const forms = document.querySelectorAll('.newsletter-subscription');

  if (forms.length <= 0) return;

  forms.forEach(form => {
    const submitButton = form.querySelector('button');
    const newsletterError = form.querySelector('.newsletter-error');
    const newsletterSuccess = form.parentElement.querySelector('.newsletter-success');
    const hideElementsOnSuccess = form.parentElement.querySelectorAll(".hide-on-success");
    const optinAtvCheckbox = form.querySelector('#atv');
    const optinSnowmobileCheckbox = form.querySelector('#snowmobile');

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      submitButton.classList.add('loading');
      newsletterError.classList.add('hidden');

      const formData = new FormData(e.currentTarget);

      if (optinAtvCheckbox || optinSnowmobileCheckbox) {
        formData.set('optinAtv', optinAtvCheckbox.checked ? 1 : 0);
        formData.set('optinSnowmobile', optinSnowmobileCheckbox.checked ? 1 : 0);
      }

      axios.postForm(form.getAttribute('action'), formData)
        .then((response) => {
          submitButton.classList.remove('loading');
          form.classList.add('hidden');
          if(hideElementsOnSuccess.length > 0) {
            hideElementsOnSuccess.forEach(el => {
              el.classList.add('hidden');
            });
          }
          newsletterSuccess.classList.remove('hidden');
        })
        .catch((error)  => {
          submitButton.classList.remove('loading');
          newsletterError.classList.remove('hidden');
        });
    });
  });
}
